export default "__VITE_ASSET__51272842__"